export default "__VITE_ASSET__DXLWW2eF__"